import eventbus from 'tiny-emitter/instance';

import { Text } from '../models/text';

export default class DrawingTexts {
  mouseListenerOptions = {
    passive: false,
    capture: false,
  };

  coords = Object.create(null);

  constructor(app) {
    this.app = app;
    this.canvas = this.app.canvas;
    this.svg = this.app.svg;
    this.setup();
    this.setupEventListeners();
    return this;
  }

  setup() {
    this.setCanvasCursor();
    eventbus.emit('drawing:started');
  }

  setupEventListeners() {
    this.svg.on('click', this.handleMouseClick, this);
  }

  setCanvasCursor() {
    this.svg.attr({ cursor: 'text' });
  }

  handleMouseClick(e) {
    if (e.button !== 0) return;
    const { x, y } = this.app.getTransformedCoords(e);
    const sid = this.app.currentSection && this.app.currentSection.uuid;
    const unit = Text.create({ sid, attributes: { position: [x, y] } });
    eventbus.emit('seatmap:add:unit', unit);
  }

  resetCanvasCursor() {
    this.svg.attr({ cursor: 'default' });
  }

  destroyEventListeners() {
    this.svg.off('click', this.handleMouseClick);
  }

  destroy() {
    this.resetCanvasCursor();
    this.destroyEventListeners();
  }
}
